import _ from "lodash";
import React, { useCallback, useState } from "react";
import { FormText } from "reactstrap";
import { TextInput } from "../components/inputs/final_form/TextInput";
import { LoadingIcon } from "../components/LoadingIcon";
import { api } from "../util/api";
import { useDebounced } from "../util/hooks";

const fetchLabByNpi = async (val) => {
  try {
    const response = await api.get(`/labs/find_by_npi`, { params: { npi: val } });
    return response.data;
  } catch (e) {
    return null;
  }
};

export const LabNpiMatchIdInput = ({ input, onMatchFound, selectedLabId, ...props }) => {
  const { onChange, value } = input;
  const [searchingLab, setSearchingLab] = useState(false);
  const [matchingLab, setMatchingLab] = useState(null);
  const [npiValue, setNpiValue] = useState(value);
  const debouncedFetchLabByNpi = useDebounced(fetchLabByNpi, 300);

  const handleChange = useCallback(
    async (val) => {
      setNpiValue(val);

      if (onChange) {
        onChange(val);
      }

      if (val.length !== 10) {
        setMatchingLab(null);
        return;
      }
      setSearchingLab(true);

      try {
        const matchingLab = await debouncedFetchLabByNpi(val);
        setMatchingLab(matchingLab);
        onMatchFound(matchingLab?.id || null, matchingLab?.npi);
      } catch (err) {
        console.error(err);
      } finally {
        setSearchingLab(false);
      }
    },
    [onChange, setSearchingLab, onMatchFound, debouncedFetchLabByNpi]
  );
  if (!onChange) {
    onMatchFound(selectedLabId, npiValue);
  }
  const matchingProviderName = matchingLab?.lab_name;
  return (
    <>
      <TextInput {...props} input={{ ...input, value: npiValue, onChange: (e) => handleChange(e.target.value) }}>
        <>
          {searchingLab ? (
            <FormText>
              <LoadingIcon /> Searching for provider...
            </FormText>
          ) : matchingLab ? (
            <FormText> Provider's Name: {matchingProviderName}</FormText>
          ) : (
            <></>
          )}
        </>
      </TextInput>
    </>
  );
};
